<template>
  <div class="modal" @click="$emit('close')">
    <div class="content" @click="$event.stopPropagation()">
      <div class="header">
        <span class="title">{{ title }}</span>
        <img class="close" src="@/assets/icons/close.svg" @click="$emit('close')" />
      </div>
      <p class="description">{{ message }}</p>
      <div class="actions">
        <button class="confirm" @click="$emit('onConfirm')">
          Da
        </button>
        <button class="cancel" type="button" v-on:click="$emit('close')">Odustani</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: {
    title: String,
    message: String,
    confirmLabel: {
      type: String,
      default: 'Da',
    },
    cancelLabel: {
      type: String,
      default: 'Odustani',
    },
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100000;
  overflow-y: hidden;
  background-color: rgba(0, 0, 0, 0.4);
}

.content {
  width: 340px;
  margin-top: auto;
  margin-bottom: auto;
  background-color: #162426;
  border-radius: 20px;
  padding: 24px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 34px;
  align-items: center;
}

.title {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
}

.close {
  cursor: pointer;
}

.description {
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  margin-bottom: 40px;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.confirm {
  padding: 12px 32px;
  border-radius: 15px;
  margin-right: 8px;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.8);
  cursor: pointer;
}

.cancel {
  padding: 12px 32px;
  border-radius: 15px;
  margin-right: 8px;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  background-color: #bb2537;
  border: 0;
  cursor: pointer;
}
</style>
